export default __webpack_public_path__ + "static/media/WB_logo_white.1193593d.svg";